import PropTypes from "prop-types";
import classNames from "classnames";

const FilterIcon = ({ className, size = 16, fill = "currentColor", ...props }) => {
	const filterIconClassName = classNames("filter-icon", className);

	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={filterIconClassName}
			{...props}
		>
			<path
				d="M14.1 1.8667H1.9667C1.63337 1.8667 1.3667 2.13337 1.3667 2.4667V4.2667C1.3667 4.40003 1.3667 4.4667 1.50003 4.60003L5.70003 7.73337H5.7667C5.9667 8.00003 6.10003 8.2667 6.10003 8.53336L6.70003 13.8C6.70003 13.9334 6.7667 14.0667 6.90003 14.1334C6.90003 14.1334 7.03337 14.1334 7.10003 14.1334C7.1667 14.1334 7.23337 14.1334 7.30003 14.1334L9.03337 13.2667C9.1667 13.2667 9.23337 13.0667 9.23337 13L9.90003 8.53336C9.90003 8.2667 10.1 8.00003 10.3 7.80003L14.5 4.6667C14.5667 4.60003 14.6334 4.4667 14.6334 4.33337V2.53337C14.6334 2.20003 14.3667 1.93337 14.0334 1.93337L14.1 1.8667Z"
				fill={fill}
			/>
		</svg>
	);
};

FilterIcon.propTypes = {
	className: PropTypes.string,
	fill: PropTypes.string,
	size: PropTypes.number,
};

export default FilterIcon;
